<template>
  <div>
    <page-table :data-api="this.api.user" :viewable="false" keyField="id">
      <el-table-column prop="id" label="编号" width="80">
      </el-table-column>
      <el-table-column prop="username" label="用户名">
      </el-table-column>
      <el-table-column prop="enabled" label="是否启用">
        <template slot-scope="scope">
          {{scope.row.enabled}}
        </template>
      </el-table-column>
      <el-table-column prop="createDate" label="添加时间">
      </el-table-column>
    </page-table>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  created: function () {},
  methods: {}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// List.vue?0729827a